module.exports = __webpack_public_path__ + "d70a5be63c9f73691954560382a5354f.jpg";